<template>
  <div class="privacy-policy">
    <section class="page-section">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1 class="section-title">
              {{ $t('label.title.privacyPolicy') }}
            </h1>
          </div>
          <privacy-policy-english />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PrivacyPolicyEnglish from '../components/documents/privacy/PrivacyPolicyEnglish'

export default {
  name: 'PrivacyPolicy',
  metaInfo: {
    title: 'Privacy policy',
    titleTemplate: '%s | Cash Hero',
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'Cash hero website' }
    ]
  },
  components: { PrivacyPolicyEnglish }
}
</script>

<style scoped>
  h4 {
    margin: 20px 0;
  }
</style>
